import reduxKeys from "../../constants/reduxKeys";
import { formatListItems } from "../../utils";

 // reducers.js
 const initialState = {
    companies: [],
    total: 0
  };

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case reduxKeys.SET_COMPANIES:
        const { companies, total } = action.payload;
        const list = formatListItems(companies, "companyId", "companyName");
        return { ...state, companies: list, total };
      default:
        return state;
    }
  };

  export default reducer;